"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestAreasResponseSchema = exports.MergedRestAreaSchema = exports.SetRestAreaDuplicateDtoSchema = exports.RestAreaRouteParamsSchema = exports.UpsertRestAreaOverrideDtoSchema = void 0;
const zod_1 = require("zod");
const rest_area_1 = require("./rest-area");
/** Body of `PUT iap/rest-areas/{id}/override`. Every field is nullable — `null` clears the override, `undefined`/omitted leaves it unset. */
exports.UpsertRestAreaOverrideDtoSchema = zod_1.z.object({
    title: zod_1.z.string().nullable().optional(),
    lat: zod_1.z.number().nullable().optional(),
    lon: zod_1.z.number().nullable().optional(),
    numberOfSpaces: zod_1.z.number().nullable().optional(),
    category: zod_1.z.string().nullable().optional(),
    address: rest_area_1.RestAreaAddressSchema.nullable().optional(),
    features: rest_area_1.RestAreaFeaturesSchema.nullable().optional(),
    isActive: zod_1.z.boolean().nullable().optional(),
    isBookable: zod_1.z.boolean().nullable().optional(),
    withAvailability: zod_1.z.boolean().nullable().optional(),
    freeOfCharge: zod_1.z.boolean().nullable().optional(),
    additionalPricingInfo: zod_1.z.string().nullable().optional(),
    description: zod_1.z.string().nullable().optional(),
    detailedDescription: zod_1.z.string().nullable().optional(),
    latestCheckIn: zod_1.z.string().nullable().optional(),
    contact: rest_area_1.RestAreaContactSchema.nullable().optional(),
    notes: zod_1.z.string().nullable().optional(),
});
/** `RestAreaEntity.id` is an `nvarchar(255)` value, not a UUID — validate shape, not format. */
exports.RestAreaRouteParamsSchema = zod_1.z.object({
    id: zod_1.z.string().min(1).max(255),
});
/** Body of `POST iap/rest-areas/{id}/duplicate`. `null` clears the duplicate relationship. */
exports.SetRestAreaDuplicateDtoSchema = zod_1.z.object({
    mainRestAreaId: zod_1.z.string().nullable(),
});
exports.MergedRestAreaSchema = zod_1.z.object({
    id: zod_1.z.string(),
    externalId: zod_1.z.string(),
    origin: zod_1.z.string(),
    title: zod_1.z.string(),
    lat: zod_1.z.number(),
    lon: zod_1.z.number(),
    numberOfSpaces: zod_1.z.number().nullable(),
    category: zod_1.z.string(),
    address: rest_area_1.RestAreaAddressSchema,
    features: rest_area_1.RestAreaFeaturesSchema,
    pricing: zod_1.z.array(rest_area_1.PricesSchema).nullable(),
    isBookable: zod_1.z.boolean(),
    withAvailability: zod_1.z.boolean(),
    freeOfCharge: zod_1.z.boolean(),
    additionalPricingInfo: zod_1.z.string().nullable(),
    description: zod_1.z.string().nullable(),
    detailedDescription: zod_1.z.string().nullable(),
    latestCheckIn: zod_1.z.string().nullable(),
    contact: rest_area_1.RestAreaContactSchema.nullable(),
    isActive: zod_1.z.boolean(),
    duplicateOfId: zod_1.z.string().nullable(),
    duplicates: zod_1.z.array(rest_area_1.RestAreaDuplicateSummarySchema),
    override: zod_1.z
        .object({
        id: zod_1.z.string(),
        notes: zod_1.z.string().nullable(),
        updatedAt: zod_1.z.string().datetime(),
    })
        .nullable(),
    lastSeenAt: zod_1.z.string().datetime(),
    createdAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
});
exports.RestAreasResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.MergedRestAreaSchema),
});
//# sourceMappingURL=rest-area-admin.js.map